"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZTextArea = void 0;
const React = __importStar(require("react"));
const kendo_react_labels_1 = require("@progress/kendo-react-labels");
const LocalizedComponent_1 = require("../../languages/LocalizedComponent");
const __1 = require("../");
const styled_components_1 = __importDefault(require("styled-components"));
class ZTextAreaComponent extends React.Component {
    constructor(props) {
        super(props);
        this.TextArea = React.forwardRef((props, ref) => {
            const [value, setValue] = React.useState(props.value || props.defaultValue || props.placeholder), { valid, ignoreFVS, ...otherProps } = props, textAreaProps = {
                ...otherProps,
                onChange: (e) => {
                    props.onChange && props.onChange(e);
                    setValue(e.target.value);
                },
                onFocus: (e) => {
                    this.setState({ focused: true });
                },
                onBlur: (e) => {
                    this.setState({ focused: false });
                }
            };
            React.useEffect(() => {
                setValue(props.value);
                this.setState({ value: props.value });
            }, [props.value]);
            return (React.createElement(React.Fragment, null, props.label ? (React.createElement(kendo_react_labels_1.FloatingLabel, { label: props.label, editorValue: value ? `${value}` : undefined, className: "none" },
                React.createElement("textarea", Object.assign({ className: `k-textarea`, ref: ref }, textAreaProps)))) : (React.createElement("textarea", Object.assign({ ref: ref, className: `k-textarea` }, props)))));
        });
        this.state = { focused: false, value: props.value || props.defaultValue };
        this.input = React.createRef();
    }
    setValue(value) {
        this.setState({ value }, () => {
            this.props.onChange &&
                this.props.onChange({
                    target: { value: value || "" }
                }, value, false);
        });
    }
    render() {
        const { Id, editable, ...otherProps } = this.props;
        return (React.createElement(__1.RequiredDot, { required: this.props.required, raisedTransform: "left-4", loweredTransform: "left-12 down-14", raised: !!this.state.value || this.state.focused },
            React.createElement("div", { className: [
                    this.props.className,
                    "z-component z-textarea",
                    this.props.disabled ? "disabled" : "",
                    this.props.valid === false ? "k-state-invalid" : ""
                ].join(" ") },
                React.createElement(LocalizedComponent_1.LocalizedComponent, Object.assign({}, otherProps),
                    React.createElement(this.TextArea, Object.assign({}, otherProps, { value: this.state.value !== undefined
                            ? this.state.value || ""
                            : otherProps.value, ref: this.input }))))));
    }
}
exports.ZTextArea = styled_components_1.default(ZTextAreaComponent) `
   font-family: ${props => props.theme["font-family"]};
   font-size: 16px;
   resize: ${props => props.resize || "none"};
   height: ${props => props.height || 200}px;
   width: ${props => props.width || 400}px;

   &[disabled]:hover {
      background: transparent;
   }

   background: transparent;

   textarea& {
      &:not([disabled]) {
         &:hover {
            background: ${props => props.theme["input-background-hover-color"]};
         }
         background: transparent;
      }
      border: 1px ${props => (props.disabled ? "dashed" : "solid")}
         ${props => props.disabled
    ? props.theme["disabled-color"]
    : props.theme["input-border-color"]};
      outline: none;
      padding: 10px;
   }

   &.z-textarea {
      display: inline-block;
      & .k-textbox-container {
         width: unset;
         background: transparent;
         & textarea {
            background-color: ${props => props.valid === false
    ? props.theme["validation-background-color"]
    : "transparent"};
            border-color: ${props => props.valid === false
    ? props.theme["validation-border-color"]
    : props.theme["input-border-color"]};
            &:hover {
               background: ${props => props.valid === false
    ? props.theme["validation-background-color"]
    : props.theme["input-background-hover-color"]};
               border-color: rgba(0, 0, 0, 0.87);
            }
         }
      }
      height: fit-content;
      & .k-label {
         left: 9px;
         background: transparent;
      }
   }
`;
//# sourceMappingURL=ZTextArea.js.map